<template lang="pug">
  .boughtOnlineSlide.blue-background(ref="boughtOnlineSlide")
    .max-width-grid
      BoughtOnlineBg
      pieChart
      h4.white How many gifts are bought online?
      .text-block
        h1 55%
        p of consumers anticipate making holiday purchases online.<span class="super white"><a href="https://nrf.com/insights/holiday-and-seasonal-trends/winter-holidays" target="_blank">4</a></span>
</template>

<script>
import debug from 'debug'
import pieChart from '@/assets/img/pieCharts/howManyOnlineGifts.svg'
import BoughtOnlineBg from '@/assets/img/svgs/presentBg.svg'

let log = debug('component:BoughtOnlineSlide')

export default {
  name: 'boughtOnlineSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const chart = this.$el.querySelector('.pieChart')

    this.timeline = new TimelineLite({ paused: true })
      .set(chart, {strokeDasharray:700})
      .fromTo(chart, 1.5, {strokeDashoffset:700, strokeDasharray:700}, { strokeDashoffset:0, ease: Power0.easeNone }, 0.5)
  },
  
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    BoughtOnlineBg,
    pieChart
  },
}
</script>

<style scoped lang="scss">
.boughtOnlineSlide {
  height: 41rem;
  padding-top: 5rem;
  h1 {
    color: #000;
  }

  h4 {
    text-align: center;
    padding-bottom: 4.8rem;
  }

  p {
    color: #fff;
  }

  svg {
    position: absolute;
    &:first-of-type {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    &:last-of-type {
      width: 17%;
      top: 50%;
      transform: translateY(-50%);
      left: 30%;
    }
  }

  .text-block {
    width: 19%;
    left: 50%;
    top: 35%;
  }

  @media #{$mobile} {
    svg {
      &:first-of-type { display: none; }
      &:last-of-type {
        width: 18%;
        top: 54%;
      }
    }

    .text-block {
      width: 30%;
      top: 34%;
    }
  }

}
</style>
